import { render, staticRenderFns } from "./SfBullets.vue?vue&type=template&id=00c88880&functional=true"
import script from "./SfBullets.vue?vue&type=script&lang=js"
export * from "./SfBullets.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBullets.vue?vue&type=style&index=0&id=00c88880&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "1ffc4376"
  
)

export default component.exports